/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from 'react'

// @mui material components
import Grid from '@mui/material/Grid'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Icon from '@mui/material/Icon'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDButton from 'components/MDButton'

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import Footer from 'examples/Footer'
import ComplexProjectCard from './components/ProjectCards/ComplexProjectCard'

// Project page components
// import Header from "layouts/pages/profile/components/Header";

import logoSlack from 'assets/images/small-logos/sandbox.svg'
import { useParams } from 'react-router-dom'
import { useAppServices } from 'hook/services'
import CreateModal from './Modals/Create'
import Loader from 'examples/Loader'
import Swal from 'sweetalert2'
import { InboxIcon } from 'lucide-react'
const plans = [
  {
    id: 'free_plan',
    features: {
      no_of_apps: 5,
    },
  },
  {
    id: '683e275ef2a53d7a9b107112',
    features: {
      no_of_apps: 5,
    },
  },
  {
    id: '683e278448b9b57c28719ea2',
    features: {
      no_of_apps: 10,
    },
  },
  {
    id: '683e27d8435f27266627a8e6',
    features: {
      no_of_apps: 20,
    },
  },
  {
    id: '683e281148b9b55a91719f03',
    features: {
      no_of_apps: 30,
    },
  },
]
function AllApps() {
  const { company_id, app_id, app_type, planId } = useParams()
  const Service = useAppServices()
  // ComplexProjectCard dropdown menu state
  const [processing, setProcessing] = useState(true)
  const [locationsLoader, setLocationsLoader] = useState(true)
  const [Apps, setApps] = useState([])
  const [snapshots, setSnapshots] = useState([])
  const [locations, setLocations] = useState([])
  const getData = async () => {
    const { response } = await Service.snapshot_onboarding.get({
      query: `company_id=${company_id}&main_app_id=${app_id}&app_type=${app_type}`,
    })

    if (response) {
      setApps(response.data)
      setProcessing(false)
    } else {
      setProcessing(false)
    }
  }
  const getSnapshots = async () => {
    const { response } = await Service.snapshot_onboarding.get_snapshots({
      query: `company_id=${company_id}&app_id=${app_id}`,
    })

    if (response) {
      setSnapshots(
        response?.data?.map((item) => ({
          label: item.name,
          value: item.id,
        }))
      )
      setProcessing(false)
    } else {
      setProcessing(false)
    }
  }
  const getLocations = async () => {
    const { response } = await Service.snapshot_onboarding.get_locations({
      query: `company_id=${company_id}&app_id=${app_id}`,
    })

    if (response) {
      setLocations(
        response?.data?.map((item) => ({
          label: item.name,
          value: item.id,
        }))
      )
      setLocationsLoader(false)
    } else {
      setLocationsLoader(false)
    }
  }
  const onLoad = () => {
    getLocations()
    if (app_type == 'snapshot') {
      getSnapshots()
    }
    getData()
  }
  useEffect(async () => {
    onLoad()
  }, [])
  // Copy
  const [copy, setCopy] = useState(false)

  const copyToClipboard = () => {
    const text = `<script src="https://api.alltheapps.io/api/agency_app/hideAppGlobalConfigue/addCustomValue"></script>`

    // Create a temporary textarea element to hold the text
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.setAttribute('readonly', '')
    textarea.style.position = 'absolute'
    textarea.style.left = '-9999px'

    // Append the textarea to the body
    document.body.appendChild(textarea)

    // Select the text inside the textarea
    textarea.select()

    // Execute the copy command
    document.execCommand('copy')
    setCopy(true)
    // Remove the textarea from the DOM
    document.body.removeChild(textarea)

    setTimeout(() => {
      setCopy(false)
    }, 2000)
  }
  const handleLimitReach = () => {
    Swal.fire({
      icon: 'warning',
      title: 'Plan Limit Reached',
      text: 'Please upgrade your plan to create more apps',
      showConfirmButton: true,
    })
  }
  return (
    <>
      <MDBox pb={3}>
        <Grid container alignItems="center">
          {/* <Grid item xs={12} md={7}>
            <MDBox mb={1}>
              <MDTypography variant="h5">Some of Our Awesome Projects</MDTypography>
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="body2" color="text">
                This is the paragraph where you can write more details about your projects. Keep you
                user engaged by providing meaningful information.
              </MDTypography>
            </MDBox>
          </Grid> */}
          <Grid item xs={12} sx={{ textAlign: 'right' }}>
            {plans.find((item) => item.id == planId).features.no_of_apps == Apps.length ? (
              <MDButton variant="gradient" color="info" onClick={handleLimitReach}>
                <Icon>add</Icon>&nbsp; Add New{' '}
              </MDButton>
            ) : (
              <CreateModal
                handleChange={onLoad}
                snapshots={snapshots}
                locations={locations}
                locationsLoader={locationsLoader}
              />
            )}
            {/* <MDButton
              sx={{ marginLeft: 3 }}
              variant="outlined"
              color="info"
              onClick={copyToClipboard}
            >
              {copy ? 'Copied' : 'Copy Script'}
            </MDButton> */}
          </Grid>
        </Grid>
        {processing ? (
          <Loader />
        ) : (
          <MDBox mt={5}>
            {Apps.length === 0 ? (
              <MDBox
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                height="300px"
                textAlign="center"
                p={3}
                sx={{
                  marginX: '5rem',
                  border: '1px dashed',
                  borderColor: 'secondary.main',
                  borderRadius: '8px',
                  backgroundColor: 'background.paper',
                }}
              >
                <MDBox mb={2}>
                  <Icon fontSize="large" color="secondary">
                    <InboxIcon />
                  </Icon>
                </MDBox>
                <MDTypography variant="h5" fontWeight="medium" gutterBottom>
                  No Apps Found
                </MDTypography>
                <MDTypography variant="body2" color="text.secondary" mb={3}>
                  You haven't created any apps yet. Get started by adding a new one.
                </MDTypography>
              </MDBox>
            ) : (
              <Grid container spacing={3}>
                {Apps.map((App) => (
                  <Grid item xs={12} md={6} lg={4} key={App.app_id}>
                    <MDBox mb={1.5} mt={1.5}>
                      <ComplexProjectCard
                        image={logoSlack}
                        title={App.app_name}
                        app={App}
                        description={App.app_id}
                        app_type={app_type}
                        dateTime={App.createdAt.split('T')[0]}
                      />
                    </MDBox>
                  </Grid>
                ))}
              </Grid>
            )}
          </MDBox>
        )}
      </MDBox>
    </>
  )
}

export default AllApps
